import React from "react";
import moment from "moment";
import userService from "../services/userService";
import SecondaryCareRequestForm from "../components/forms/SecondaryCareRequestForm";
import LoadingScreen from "../components/LoadingScreen";
import MainContent from "../components/boxes/MainContent";
import PageHeader from "../components/boxes/PageHeader";
import PageBody from "../components/boxes/PageBody";
import Modal from "../components/boxes/Modal";
import { useTranslation, withTranslation } from "react-i18next";
import { envVariables } from "../config/appConfig";
import { capitalizeFirstLetter } from "../utils/helpers";

class SecondaryCareContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      availableCare: [],
      selectedSecondaryCare: null,
      showRequestCareModal: false,
      showRequestResultModal: false,
      secondaryCareRequestResult: null,
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    userService.getSecondaryCareBenefits().then((benefits) => {
      const order = ["Gym", "Spa"];
      const sorted = [...benefits].sort((a, b) => {
        const ai = order.indexOf(a.name);
        const bi = order.indexOf(b.name);
        if (ai === -1 && bi === -1) return 0;
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
      });
      this.setState({
        isLoading: false,
        availableCare: sorted,
      });
    });
  }

  toggleRequestModal = () => {
    this.setState({
      showRequestCareModal: !this.state.showRequestCareModal,
    });
  };

  setSelectedSecondaryCare = (careId, careName, typeId) => {
    this.toggleRequestModal();
    this.setState({
      selectedSecondaryCare: {
        careId,
        careName,
        typeId,
      },
    });
  };

  requestSecondaryCare = (values) => {
    if (values.provider_id && Number(values.provider_id) !== -1) {
      this.setState({
        isLoading: true,
        showRequestCareModal: false,
      });
      userService
        .requestSecondaryCare(
          this.state.selectedSecondaryCare.careId,
          values.provider_id,
          values.date_time
        )
        .then((result) => {
          this.setState({
            isLoading: false,
            secondaryCareRequestResult: result,
            showRequestResultModal: true,
          });
        })
        .catch((err) => {
          this.setState({
            isLoading: false,
            secondaryCareRequestResult: {
              message: err.response.data.message,
              paCode: null,
            },
            showRequestResultModal: true,
          });
        });
    }
  };

  hideRequestResultModal = () => {
    this.setState({
      showRequestResultModal: false,
      secondaryCareRequestResult: null,
    });
  };

  careUsedTranslated = (careUsed) => {
    const { t } = this.props;

    switch (careUsed) {
      case 0:
        return t("general.0");
      case 1:
        return t("general.1");
      case 2:
        return t("general.2");
      case 3:
        return t("general.3");
      default:
        return careUsed;
    }
  };

  render() {
    const { user, t } = this.props;
    const {
      isLoading,
      availableCare,
      showRequestCareModal,
      selectedSecondaryCare,
      showRequestResultModal,
      secondaryCareRequestResult,
    } = this.state;

    if (isLoading) {
      return (
        <MainContent>
          <PageHeader
            title={t("accessSecondaryCare.pageTitle")}
          />
          <PageBody>
            <LoadingScreen />
          </PageBody>
        </MainContent>
      );
    }

    return (
      <MainContent>
        <PageHeader title={t("accessSecondaryCare.pageTitle")} />
        <PageBody>
          <React.Fragment>
            {showRequestCareModal && selectedSecondaryCare.careName === "Spa" && envVariables.COUNTRY_LOCALE === "en-NG" && (
              <SpaBookingInfoModal onClose={this.toggleRequestModal} />
            )}

            {showRequestCareModal && !(selectedSecondaryCare.careName === "Spa" && envVariables.COUNTRY_LOCALE === "en-NG") && (
              <SecondaryCareRequestModal
                accessToken={user.credentials.accessToken}
                careName={selectedSecondaryCare.careName}
                typeId={selectedSecondaryCare.typeId}
                onRequest={this.requestSecondaryCare}
                onClose={this.toggleRequestModal}
              />
            )}

            {showRequestResultModal && (
              <RequestResultModal
                careName={selectedSecondaryCare.careName}
                result={secondaryCareRequestResult}
                onClose={() => window.location.reload(true)}
              />
            )}
            <div className="dashboard-card secondary-care-contact">
              <h2>
                {`${t("accessSecondaryCare.forOtherSecondaryCare")} `}
                <a href={`mailto: ${envVariables.CONTACT_EMAIL}`}>
                  {envVariables.CONTACT_EMAIL}
                </a>{" "}
                {`${t("or", { ns: "common" })} `}
                <a href={`tel:${envVariables.CONTACT_PHONE_NUMBER}`}>
                  {" "}
                  {envVariables.CONTACT_PHONE_NUMBER}
                </a>
              </h2>
            </div>

            <div className="sc-card-wrap">
              {availableCare && availableCare.length > 0 ? (
                availableCare.map((care) => (
                  <div
                    className="dashboard-card sc-card"
                    key={care.id}
                    onClick={() => {
                      if (
                        care.is_accessible &&
                        parseInt(care.limit[0]) > 0 &&
                        care.used < parseInt(care.limit[0])
                      )
                        this.setSelectedSecondaryCare(
                          care.id,
                          care.name,
                          care.provider_type_id
                        );
                    }}
                  >
                    <i
                      className={`fas fa-5x ${
                        care.name === "Spa" ? "fa-spa" : "fa-dumbbell"
                      }${
                        care.used === care.limit ||
                        care.limit === 0 ||
                        !care.is_accessible
                          ? " disabled"
                          : ""
                      }`}
                    ></i>
                    <h2 className="sc-card__title-text">
                      {t(`accessSecondaryCare.${care.name.toLowerCase()}`)}
                    </h2>

                    {care.is_accessible &&
                    care.used < parseInt(care.limit[0]) ? (
                      <React.Fragment>
                        <p className="sc-card__text">
                          {t("accessSecondaryCare.careLimitAndFrequencyCountInfo", {
                            limit: care.limit,
                            frequency: care.frequency,
                            interpolation: { escapeValue: false },
                          })}
                        </p>
                        <br></br>
                        <p className="sc-card__text">
                          {t("accessSecondaryCare.careUseInfo", {
                            count: care.used,
                          })}
                          .
                        </p>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        {care.used >= care.limit ? (
                          <p className="sc-card__text">
                            {t("accessSecondaryCare.careSlotUsedUpMessage")}
                          </p>
                        ) : (
                          <p className="sc-card__text">
                            {t("accessSecondaryCare.careNotAvailableMessage")}
                          </p>
                        )}
                        <p className="sc-card__text"> ... </p>
                      </React.Fragment>
                    )}
                  </div>
                ))
              ) : (
                <div style={{ marginTop: "5rem" }}>
                  <p
                    style={{
                      fontSize: "2.5rem",
                      color: "#ccc",
                      fontWeight: "bolder",
                    }}
                  >
                    {t("accessSecondaryCare.secondaryCareNotAvailableMessage")}
                  </p>
                </div>
              )}
            </div>
          </React.Fragment>
        </PageBody>
      </MainContent>
    );
  }
}

const SpaBookingInfoModal = ({ onClose }) => {
  const { t } = useTranslation(["benefits"]);

  const steps = [
    t("accessSecondaryCare.spaStep1Body"),
    t("accessSecondaryCare.spaStep2Body"),
    t("accessSecondaryCare.spaStep3Body"),
    t("accessSecondaryCare.spaStep4Body"),
  ];

  const linkStyle = { textDecoration: "underline", color: "inherit" };

  return (
    <Modal
      title={t("accessSecondaryCare.howToBookSpaModalTitle")}
      onClose={onClose}
      modalContentStyle={{ alignItems: "flex-start", maxWidth: "440px", width: "100%", minHeight: "unset" }}
      style={{ color: "#111", textTransform: "none", textAlign: "left", fontSize: "2.4rem", fontWeight: 600 }}
    >
      <div style={{ paddingTop: "8px" }}>
        <p style={{ margin: "0 0 16px", fontSize: "14px", color: "#4f4f4f" }}>
          {t("accessSecondaryCare.spaModalIntro")}
        </p>

        {steps.map((step, index) => (
          <div
            key={index}
            style={{ display: "flex", gap: "16px", alignItems: "flex-start", padding: "8px 0" }}
          >
            <div
              style={{
                flexShrink: 0,
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: "#ecf5fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#137cc1",
                fontWeight: 500,
                fontSize: "16px",
              }}
            >
              {index + 1}
            </div>
            <p style={{ margin: "auto 0", fontSize: "14px", color: "#4f4f4f", lineHeight: 1.5 }}>
              {step}
            </p>
          </div>
        ))}

        <div style={{ marginTop: "24px", paddingTop: "16px", borderTop: "1px solid #eee" }}>
          <p style={{ margin: "0 0 8px", fontWeight: 600, fontSize: "14px", color: "#000" }}>
            {t("accessSecondaryCare.spaFindSpaTitle")}
          </p>
          <p style={{ margin: "0 0 8px", fontSize: "14px", color: "#4f4f4f", lineHeight: 1.5 }}>
            {t("accessSecondaryCare.spaFindSpaDownloadPrefix")}{" "}
            <a href={envVariables.RELIANCE_ANDROID_APP_DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
              {t("accessSecondaryCare.spaGoogleStoreLabel")}
            </a>{" "}
            {t("accessSecondaryCare.spaFindSpaDownloadMiddle")}{" "}
            <a href={envVariables.RELIANCE_IOS_APP_DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
              {t("accessSecondaryCare.spaAppleStoreLabel")}
            </a>
            {"."}
          </p>
          <p style={{ margin: 0, fontSize: "14px", color: "#4f4f4f", lineHeight: 1.5 }}>
            {t("accessSecondaryCare.spaFindSpaInstructions")}
          </p>
        </div>
      </div>
    </Modal>
  );
};

const SecondaryCareRequestModal = ({
  accessToken,
  typeId,
  careName,
  onRequest,
  onClose,
}) => {
  const { t } = useTranslation(["benefits"]);

  return (
    <Modal
      title={t(`accessSecondaryCare.access${capitalizeFirstLetter(careName)}ModalTitle`)}
      onClose={onClose}
    >
      <SecondaryCareRequestForm
        accessToken={accessToken}
        typeId={typeId}
        careName={careName}
        onSubmit={onRequest}
      />
    </Modal>
  );
};

const RequestResultModal = ({ careName, result, onClose }) => {
  const { t, i18n } = useTranslation(["benefits"]);

  const locale = i18n.language === "en" ? "en-gb" : i18n.language;

  return (
    <Modal
      title={t(`accessSecondaryCare.access${capitalizeFirstLetter(careName)}ModalTitle`)}
      onClose={onClose}
    >
      <div className="pa-code-modal">
        {result.paCode ? (
          <div className="code_holder">
            <p className="message">{t("accessSecondaryCare.gymRequestSuccessMessage")}</p>
            <p>{t("accessSecondaryCare.generatedCodeMessage")}</p>
            <h2 className="code">{result.paCode}</h2>
            <div className="date">
              <b>
                {t("accessSecondaryCare.codeCreationDate", {
                  date: result.created_at
                    ? moment(result.created_at)
                        .locale(locale)
                        .format("DD MMM YYYY, h:mm a")
                    : moment().locale(locale).format("DD MMM YYYY, h:mm a"),
                })}
              </b>
              {result.expired_at && (
                <span>
                  {` ${t("accessSecondaryCare.codeWillExpireText")} ${moment(
                    result.expired_at
                  )
                    .locale(locale)
                    .format("DD MMM YYYY, h:mm a")}`}
                </span>
              )}
            </div>
            <p>{t("accessSecondaryCare.informationForCodeGeneration")}</p>
          </div>
        ) : (
          <p className="spa-success-message message">
            {t("accessSecondaryCare.requestSuccessMessage")}
          </p>
        )}
        <hr />
        <p>
          {`${t("accessSecondaryCare.helpOrEnquiresMessage")} `} <br />
          {`${t("accessSecondaryCare.helpDeskMessage")} `}
          <br />
          <a href={`mailto: ${envVariables.CONTACT_EMAIL}`}>
            {envVariables.CONTACT_EMAIL}
          </a>{" "}
          {t("or", { ns: "common" })} {" "}
          <a href={`tel:${envVariables.CONTACT_PHONE_NUMBER}`}>
            {envVariables.CONTACT_PHONE_NUMBER}
          </a>
        </p>
      </div>
    </Modal>
  );
};

const SecondaryCareContainerWithTranslation = withTranslation(["benefits"])(
  SecondaryCareContainer
);
export default SecondaryCareContainerWithTranslation;
